import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyToSymbolPipe'
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyToSymbolPipe implements PipeTransform {

  transform(currency: string): string {
    switch (currency) {
      case 'EUR' : return ' €';
      default: return currency;
    }
  }

}
